export const TARGETING_ATTRIBUTE = {
  age: 'age',
  language: 'language',
  arm: 'arm',
  periodPhase: 'period_phase',
  siteLocation: 'site_location',
}

export const TARGETING_OPERATOR = {
  equals: 'equals',
  notEquals: 'not_equals',
  gte: 'gte',
  lte: 'lte',
}

export const AGE_BASIS = {
  atEnrollment: 'at_enrollment',
  current: 'current',
}

export const TARGETING_ATTRIBUTE_OPTIONS = [
  { key: TARGETING_ATTRIBUTE.age, text: 'Age' },
  { key: TARGETING_ATTRIBUTE.language, text: 'Language' },
  { key: TARGETING_ATTRIBUTE.arm, text: 'Arm' },
  { key: TARGETING_ATTRIBUTE.periodPhase, text: 'Phase' },
  { key: TARGETING_ATTRIBUTE.siteLocation, text: 'Site-Location' },
]

export const AGE_BASIS_OPTIONS = [
  { key: AGE_BASIS.atEnrollment, text: 'Age at enrollment' },
  { key: AGE_BASIS.current, text: 'Current age' },
]

export const DEFAULT_OPERATORS = [
  { key: TARGETING_OPERATOR.equals, text: 'is' },
  { key: TARGETING_OPERATOR.notEquals, text: 'is not' },
]

export const AGE_OPERATORS = [
  { key: TARGETING_OPERATOR.equals, text: 'is' },
  { key: TARGETING_OPERATOR.gte, text: '≥' },
  { key: TARGETING_OPERATOR.lte, text: '≤' },
]

export const SET_BY_ANCHOR_LABEL = 'SET BY THE ANCHOR'
